module.exports = __webpack_public_path__ + "static/media/Rating Changed.f8a09e09.png";